export default __webpack_public_path__ + "static/media/headerImg.11811607.svg";